import api from "./api";

export type Badge = {
  id: string;
  code: string;
  name: string;
  description: string;
  icon_emoji: string | null;
  icon_image_url: string | null;
  color: string;
  tier: string;
  category: string | null;
  criteria: any;
  is_active: boolean;
  created_at: string;
  // Present on GET /badges (admin catalogue): how many athletes earned it.
  earner_count?: number;
};

// One row per active badge annotated for the athlete's collection page.
export type BadgeProgress = {
  id: string;
  code: string;
  name: string;
  description: string;
  icon_emoji: string | null;
  icon_image_url: string | null;
  color: string;
  tier: string;
  category: string | null;
  earned: boolean;
  earned_at: string | null;
  progress: { current: number; target: number } | null;
};

export type UserBadge = {
  id: string;
  user_id: string;
  badge_id: string;
  earned_at: string;
  badge: Badge;
};

export async function listBadges() {
  const { data } = await api.get<Badge[]>("/badges");
  return data;
}

export async function listUserBadges(userId: string) {
  const { data } = await api.get<UserBadge[]>(`/badges/user/${userId}`);
  return data;
}

/** Full active catalogue annotated with my earned state + progress. */
export async function getMyBadgeProgress() {
  const { data } = await api.get<BadgeProgress[]>("/badges/me/progress");
  return data;
}

export async function createBadge(payload: Partial<Badge> & { code: string; name: string; description: string; criteria: any }) {
  const { data } = await api.post<Badge>("/badges", payload);
  return data;
}

export async function updateBadge(id: string, payload: Partial<Badge>) {
  const { data } = await api.patch<Badge>(`/badges/${id}`, payload);
  return data;
}

export async function deleteBadge(id: string) {
  await api.delete(`/badges/${id}`);
}

/**
 * Upload a custom badge icon (PNG/JPG/WebP/GIF or SVG). Returns the
 * stored URL to save as the badge's icon_image_url.
 */
export async function uploadBadgeIcon(file: File): Promise<string> {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post<{ url: string }>("/upload/badge-icon", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}
